import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 md:py-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 text-center">
          <div className="mb-6 md:mb-0">
            <h4 className="font-semibold mb-3 text-base">Social</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="https://instagram.com/tricode.cloud" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">Instagram</a></li>
              <li><a href="https://linkedin.com/company/tricode-cloud" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">LinkedIn</a></li>
            </ul>
          </div>
          
          <div className="mb-6 md:mb-0">
            <h4 className="font-semibold mb-3 text-base">Company</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="https://tricode.cloud/about-us" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">About Us</a></li>
              <li><a href="https://tricode.cloud/team" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">Team</a></li>
              <li><a href="https://tricode.cloud/contact" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">Contact Us</a></li>
            </ul>
          </div>
          
          <div className="mb-6 md:mb-0">
            <h4 className="font-semibold mb-3 text-base">Products</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="https://tricode.cloud/trievents" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">TriEvents</a></li>
              <li><a href="https://tricode.cloud/trihire" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">TriHire</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-6 pt-6 text-center text-gray-400">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-4">
            <div className="flex flex-col md:hidden items-center space-y-1">
              <a href="https://tricode.cloud/trievents/terms-of-service" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">Terms of Service</a>
              <a href="https://tricode.cloud/trievents/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm">Privacy Policy</a>
            </div>
            <span className="md:flex hidden">&copy; 2025 Tricode Cloud. All rights reserved.</span>
            <span className="md:hidden">&copy; 2025 Tricode Cloud. All rights reserved.</span>
            <span className="hidden md:inline">•</span>
            <a href="https://tricode.cloud/trievents/terms-of-service" target="_blank" rel="noopener noreferrer" className="hidden md:inline hover:text-white transition-colors text-sm">Terms of Service</a>
            <span className="hidden md:inline">•</span>
            <a href="https://tricode.cloud/trievents/privacy-policy" target="_blank" rel="noopener noreferrer" className="hidden md:inline hover:text-white transition-colors text-sm">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 